import { useState, useEffect } from 'react';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL;

// Default prefixes as fallback
const DEFAULT_PREFIXES = [
  { code: '+48', country: 'PL', flag: '🇵🇱', name: 'Polska' },
  { code: '+49', country: 'DE', flag: '🇩🇪', name: 'Niemcy' },
  { code: '+380', country: 'UA', flag: '🇺🇦', name: 'Ukraina' },
  { code: '+44', country: 'GB', flag: '🇬🇧', name: 'Wielka Brytania' },
  { code: '+1', country: 'US', flag: '🇺🇸', name: 'USA' }
];

export function usePhonePrefixes() {
  const [prefixes, setPrefixes] = useState(DEFAULT_PREFIXES);
  const [defaultPrefix, setDefaultPrefix] = useState('+48');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchPrefixes = async () => {
      try {
        const response = await axios.get(`${API}/api/phone-prefixes`);
        if (response.data?.prefixes) {
          setPrefixes(response.data.prefixes);
        }
        if (response.data?.defaultPrefix) {
          setDefaultPrefix(response.data.defaultPrefix);
        }
      } catch (error) {
        console.error('Failed to fetch phone prefixes:', error);
        // Keep defaults
      } finally {
        setLoading(false);
      }
    };

    fetchPrefixes();
  }, []);

  return { prefixes, defaultPrefix, loading };
}

export default usePhonePrefixes;
